/**
 * Operator API Client
 *
 * Handles API calls to operator-related endpoints.
 */

import { apiClient } from '@/lib/api-client';
import type { OperatorCurrentResponse } from '../types/operator.types';

/**
 * Operator API service
 */
export const operatorApi = {
  /**
   * Fetch the current operator and theme configuration.
   *
   * Uses the `Operator` header (automatically set from URL parameter)
   * to determine which operator configuration to return.
   *
   * @returns Promise resolving to operator and theme data
   * @throws Error if the request fails
   *
   * @example
   * ```typescript
   * const { operator, theme } = await operatorApi.getCurrent();
   * console.log(operator.name); // "Monta"
   * console.log(theme.primaryColor); // "#1DB954"
   * ```
   */
  async getCurrent(): Promise<OperatorCurrentResponse> {
    return apiClient.get<OperatorCurrentResponse>('/api/v1/operators/current');
  },
};
